import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Alert, Tooltip, Stack, Typography, Link, Box } from '@mui/material';
import Image from '../../components/image'
// auth
import { useAuthContext } from '../../auth/useAuthContext';
// routes
import { PATH_AUTH } from '../../routes/paths';
// layouts
import LoginLayout from '../../layouts/login';
//
import AuthLoginForm from './AuthLoginForm';
import AuthWithSocial from './AuthWithSocial';

// ----------------------------------------------------------------------

export default function Login() {
  const { method } = useAuthContext();

  return (
    <LoginLayout>
      <Stack spacing={2} sx={{ mb: 5, position: 'relative' }}>
      <Image
          disabledEffect
          visibleByDefault
          alt="auth"
          src={'/logo/logo-1.svg'}
          sx={{ width: '50%' }}
        />
        <Typography variant="h4">Faça seu Login</Typography>

        {/* <Stack direction="row" spacing={0.5}>
          <Typography variant="body2">É sua primeira vez por aqui?</Typography>

          <Link component={RouterLink} to={PATH_AUTH.register} variant="subtitle2" sx={{color: '#00AB55'}}>
            Crie sua conta
          </Link>
        </Stack> */}
      </Stack>
        <AuthLoginForm />
    </LoginLayout>
  );
}
